function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M7.15,7.85a.49.49,0,0,1,.7-.7L12,11.29V.5a.5.5,0,0,1,1,0V11.29l4.15-4.14a.49.49,0,1,1,.7.7l-5,5a.36.36,0,0,1-.16.11.47.47,0,0,1-.38,0,.36.36,0,0,1-.16-.11ZM24,16.5v7a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5v-7a.41.41,0,0,1,0-.19.36.36,0,0,1,.11-.16l4-4A.47.47,0,0,1,4.5,12H8a.5.5,0,0,1,0,1H4.71l-3,3H7.5a.5.5,0,0,1,.5.5V18h8V16.5a.5.5,0,0,1,.5-.5h5.79l-3-3H17a.5.5,0,0,1,0-1h2.5a.47.47,0,0,1,.35.15l4,4a.36.36,0,0,1,.11.16A.41.41,0,0,1,24,16.5ZM23,17H17v1.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5V17H1v6H23Z"
})));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.0c685a0f.svg";
export { ForwardRef as ReactComponent };